import check from './check';
export function setup(context = global || window) {
    try {
        check(context.fetch, context.Headers, context.Request, context.Response);
    } catch (_a) {
        const fetch = require('node-fetch');
        context.fetch = fetch;
        context.Headers = fetch.Headers;
        context.Request = fetch.Request;
        context.Response = fetch.Response;
    }
}
export default setup;    //# sourceMappingURL=setup.js.map
